import { render, staticRenderFns } from "./AddEmployee.vue?vue&type=template&id=37dc5c22&scoped=true&"
var script = {}
import style0 from "./AddEmployee.vue?vue&type=style&index=0&id=37dc5c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc5c22",
  null
  
)

export default component.exports